import React from 'react';
import {useProductEditState} from '../utils/editProduct';
import Toast from '../../../elements/Toast';

const BulkEditToast = () => {
  const {success, error} = useProductEditState();

  return (
    <>
      <Toast open={success} severity="success" color="success">
        Producto editado correctamente
      </Toast>
      <Toast open={error} severity="error" color="error">
        Error al editar el producto, refresca la página y vuelve a intentarlo
      </Toast>
    </>
  );
};

export default BulkEditToast;
